// OWSite
//
//  desc:
//         
//
//
//  props:
//

import './index.css'

import Body from './Body'


import React from 'react';
class OWSite extends React.Component
{
 constructor(props)
  {
    super(props)
    this.state = {

    };
  }


  render()
  {
    return(
      <div className='ow-generic-site ow_owsite_clearfix'>

        <Body>
          {this.props.children}
        </Body>

      </div>
    );
  }

}

export default OWSite;
